import styled from 'styled-components';
import { MEDIA_QUERY, Stack, getToken } from '@optimus-web/core';

export const BarItem = styled(Stack)<{ height: number }>`
    position: relative;
    overflow: hidden;
    width: 100px;
    height: ${({ height }) => height}px;
    border-radius: ${getToken('borderRadius100')}px;
    background: ${getToken('paletteBrandIndigo50')};

    ${MEDIA_QUERY.tabletMax} {
        width: 70px;
    }

    ${MEDIA_QUERY.largePhoneMax} {
        width: 40px;
    }
`;

export const UpperPart = styled.div<{ height: number }>`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: ${({ height }) => height}px;
    background: ${getToken('paletteBrandIndigo500')};
`;

export const ChartLegendMarker = styled.div`
    width: 22px;
    height: 22px;
    background: ${getToken('paletteBrandIndigo500')};
    border-radius: ${getToken('borderRadiusRound')};
`;
